export default "__VITE_ASSET__YHanGLs0__"